
// Recommended products for the armpit rash and itching article
export const armpitRashItchyRecommendedProducts = [
  {
    id: 3,
    name: "It Just Works Deodorant",
    description: "Natural deodorant free from irritating chemicals, perfect for sensitive underarm skin.",
    image: "/lovable-uploads/a38e4978-a37a-452c-a67e-140d9acc3d2e.png",
    link: "https://itjustworksdeodorant.com?sca_ref=8468108.vEEWUNzhD1"
  },
  {
    id: 2,
    name: "Kinko Care Natural Deodorant",
    description: "Gentle, vegan deodorant formulated for sensitive skin prone to rashes and irritation.",
    image: "/lovable-uploads/a2ef7eb0-0c25-4d2e-885a-ecbd6e258b4a.png",
    link: "https://www.kinko.care/?ref=rlexraps"
  }
];
